module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
  with (locals || {}) {
    ; 
var date;
var value = item[column.name];

var datetime = "-";

if ( !value && column.name == 'modifieddatetime') {
	value = item['createddatetime'];
}

if (value) {
	switch (column.input) {
		case "TZ":
			date = Date.fromTZ(value);
			break;
		case "PG":
			date = Date.fromPG(value);
			break;
		case "PGDate":
			date = Date.fromPGDate(value);
			break;
		case "Time":
			date = Date.fromTime(value);
			break;
		default:
			date = column.input ? Date.fromFormat(column.input) : Date.parse(column.input);
			break;
	}


	if (column.output) {
		datetime = date.format(column.output);
	} else {
		datetime = date.format();
	}
}


    ; __append("\n\n")
    ; __append(escapeFn( datetime ))
  }
  return __output.join("");

}